// @flow
import type {Element} from 'react'
import React from 'react'
import {values} from 'ramda'

import {Checkbox} from 'components/proposals/Part/ui'
import type {MoveItemsOptionMap, UpdateCallback} from 'components/proposals/types'
import MoveItems from '../MoveItems'
import styles from './index.scss'

type Props = $ReadOnly<{
  changeKey: string,
  roleName: string,
  destroy: boolean,
  moveItems: boolean,
  isReadonly: boolean,
  isCircle: boolean,
  isNew: boolean,
  onChange: UpdateCallback,
  policiesToMoveDown: MoveItemsOptionMap,
  rolesToMoveDown: MoveItemsOptionMap,
  policiesToMoveUp: MoveItemsOptionMap,
  rolesToMoveUp: MoveItemsOptionMap,
}>

function V5Footer({
  changeKey,
  roleName,
  destroy,
  moveItems,
  isReadonly,
  isCircle,
  isNew,
  onChange,
  policiesToMoveDown,
  rolesToMoveDown,
  policiesToMoveUp,
  rolesToMoveUp,
}: Props): Element<"div"> {
  const destroyPath = isCircle ? ['destroyCircle'] : ['destroyRole']
  const moveItemsPath = isCircle ? ['restructureCircle'] : ['expandRole']
  const moveDownItems = values(rolesToMoveDown).concat(values(policiesToMoveDown))
  const mayHaveInternalData = moveDownItems.some(({isSelected}) => isSelected) || isCircle

  return (
    <div className={styles.container}>
      <div className={styles.item}>
        <Checkbox
          id={`${changeKey}-move-items-in-out`}
          checked={moveItems}
          disabled={isReadonly}
          label={I18n.t('proposals.role_edit.move_items')}
          onChange={onChange}
          tabIndex={0}
          path={moveItemsPath}
        />
      </div>
      {moveItems && (
        <div className={styles.moveItemsContainer}>
          <MoveItems
            changeKey={changeKey}
            isReadonly={isReadonly}
            roleName={roleName}
            onChange={onChange}
            policiesToMoveDown={policiesToMoveDown}
            rolesToMoveDown={rolesToMoveDown}
            policiesToMoveUp={policiesToMoveUp}
            rolesToMoveUp={rolesToMoveUp}
            isOnV5
          />
        </div>
      )}
      {!isNew && (
        <div className={styles.item}>
          <Checkbox
            id={`#${changeKey}-remove-this-role`}
            checked={destroy}
            disabled={isReadonly}
            label={I18n.t('proposals.role_edit.remove_role')}
            onChange={onChange}
            tabIndex={0}
            path={destroyPath}
          />
        </div>
      )}
      {destroy && mayHaveInternalData && (
        <div className="has-danger">
          <div className="form-control-feedback">
            {I18n.t('proposals.role_edit.remove_circle_warning')}
          </div>
        </div>
      )}
    </div>
  )
}

export default V5Footer
